import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/icon_default_message.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-65c6f416"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-fill" }, null, -1))
const _hoisted_2 = { class: "text-center sticky-top mb-3" }
const _hoisted_3 = {
  class: "badge bg-white text-primary text-label",
  style: {"width":"76px"}
}
const _hoisted_4 = {
  key: 0,
  class: "bg-light py-3 px-3 rounded-5 d-flex mb-3 justify-content-center align-items-center position-relative"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "30",
  class: "position-absolute start-0 ms-4"
}, null, -1))
const _hoisted_6 = {
  class: "mb-0 text-center text-label",
  style: {"width":"400px"}
}
const _hoisted_7 = {
  key: 1,
  class: "text-center sticky-top"
}
const _hoisted_8 = {
  class: "badge bg-white border-light text-primary text-label",
  style: {"width":"76px"}
}
const _hoisted_9 = {
  key: 2,
  class: "chat-message-item d-flex mb-3"
}
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "flex-grow-1" }
const _hoisted_12 = { class: "d-flex align-items-center" }
const _hoisted_13 = { class: "mb-0 text-subtitle me-3" }
const _hoisted_14 = { class: "mb-0 text-label text-muted" }
const _hoisted_15 = {
  key: 0,
  class: "ms-2 text-label text-muted",
  style: {"font-size":"11px"}
}
const _hoisted_16 = {
  key: 0,
  class: "d-flex gap-2 mt-1"
}
const _hoisted_17 = ["value", "onKeyup"]
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 1,
  class: "text-paragraph mb-0"
}
const _hoisted_20 = {
  key: 0,
  class: "ms-2"
}
const _hoisted_21 = { class: "dropdown" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-sm message-menu-btn",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, " ⋮ ", -1))
const _hoisted_23 = { class: "dropdown-menu dropdown-menu-end" }
const _hoisted_24 = ["onClick"]

interface ISectionItem {
  isHeader: boolean;
  isDefault: boolean;
  title: string;
  name: string;
  time: string;
  message: string;
  image: string;
  user_id?: number;
  id?: number;
  is_edited?: boolean;
  edited_at?: string | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatRoomContent',
  props: {
    sectionItems: {},
    defaultMessage: {},
    formattedDate: {},
    sessionId: { default: null },
    editingMessageId: { default: null },
    editMessageText: { default: "" },
    canEditMessage: { type: Function, default: () => false }
  },
  emits: ["startEdit", "cancelEdit", "submitEdit", "update:editMessageText"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.formattedDate), 1)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sectionItems, (item, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
        (item.isDefault)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.defaultMessage), 1)
            ]))
          : _createCommentVNode("", true),
        (item.isHeader)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(item.title), 1)
            ]))
          : _createCommentVNode("", true),
        (!item.isHeader && !item.isDefault)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("img", {
                src: item.image,
                alt: "",
                height: "38",
                width: "38",
                class: "rounded-circle me-3 mt-1"
              }, null, 8, _hoisted_10),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("p", _hoisted_13, _toDisplayString(item.name), 1),
                  _createElementVNode("p", _hoisted_14, _toDisplayString(item.time), 1),
                  (item.is_edited || item.edited_at)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, "(editado)"))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.editingMessageId === item.id)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("input", {
                        class: "form-control form-control-sm",
                        value: _ctx.editMessageText,
                        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:editMessageText', ($event.target as HTMLInputElement).value))),
                        onKeyup: [
                          _withKeys(($event: any) => (_ctx.$emit('submitEdit', item)), ["enter"]),
                          _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.$emit('cancelEdit')), ["esc"]))
                        ]
                      }, null, 40, _hoisted_17),
                      _createElementVNode("button", {
                        class: "btn btn-sm btn-secondary",
                        onClick: ($event: any) => (_ctx.$emit('submitEdit', item))
                      }, " Salvar ", 8, _hoisted_18),
                      _createElementVNode("button", {
                        class: "btn btn-sm btn-light",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('cancelEdit')))
                      }, " Cancelar ")
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(item.message), 1))
              ]),
              (item.user_id === _ctx.sessionId && _ctx.canEditMessage(item))
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _hoisted_22,
                      _createElementVNode("ul", _hoisted_23, [
                        _createElementVNode("li", null, [
                          _createElementVNode("button", {
                            class: "dropdown-item",
                            onClick: ($event: any) => (_ctx.$emit('startEdit', item))
                          }, " ✏️ Editar mensagem ", 8, _hoisted_24)
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}
}

})